import { render } from "./Client.html?vue&type=template&id=778610bf&ts=true&external"
import script from "./Client.vue?vue&type=script&lang=ts"
export * from "./Client.vue?vue&type=script&lang=ts"

import "./Client.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__